<template>
	<section class="error__wrapper error__wrapper--no-results">
		<slot></slot>
		<div class="error__message">
			<svg-icon v-if="icon" class="error__icon" :icon="svg"></svg-icon>
			<p class="is-semibold is-size-4" v-html="$t(title)"></p>
			<p v-html="$t(message)"></p>
		</div>
	</section>
</template>

<script>
import Icon from '@/components/Icon'

export default {
	name: 'Error',
	components: {
		'svg-icon': Icon
	},
	props: {
		icon: {
			type: Boolean,
			default: true
		},
		svg: {
			type: String,
			default: 'warning'
		},
		title: {
			type: String,
			default: 'error.title'
		},
		message: {
			type: String,
			default: 'error.filter'
		},
		back: {
			type: Boolean,
			default: false
		}
	}
}
</script>
